import React from 'react';

const CATEGORIES = [
  'Kitchen', 'Service', 'Cleaning', 'Inventory', 'Catering',
  'Delivery', 'Finance', 'Marketing', 'Maintenance', 'Other',
];

export default function TaskModal({ open, onClose, editingTask, form, onChange, onSave, saving, staff }) {
  if (!open) return null;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) onClose();
  };

  const canSubmit = form.title.trim() && form.assignedTo;

  return (
    <div className="task-modal-overlay" onClick={handleOverlayClick}>
      <div className="task-modal">

        <div className="task-modal__header">
          <span className="task-modal__title">
            {editingTask ? '✏️ Edit Task' : '📋 Assign New Task'}
          </span>
          <button className="task-modal__close" onClick={onClose} aria-label="Close">✕</button>
        </div>

        <div className="task-modal__body">

          <div className="task-modal__field">
            <label className="task-modal__label">Task Title *</label>
            <input
              className="task-modal__input"
              placeholder="e.g. Clean the fryer"
              value={form.title}
              onChange={e => onChange('title', e.target.value)}
            />
          </div>

          <div className="task-modal__field">
            <label className="task-modal__label">Description</label>
            <textarea
              className="task-modal__textarea"
              placeholder="Add more details..."
              value={form.description}
              onChange={e => onChange('description', e.target.value)}
            />
          </div>

          <div className="task-modal__row">
            <div className="task-modal__field">
              <label className="task-modal__label">Assign To *</label>
              <select
                className="task-modal__select"
                value={form.assignedTo}
                onChange={e => onChange('assignedTo', e.target.value)}
              >
                <option value="">Select employee…</option>
                {staff.map(s => (
                  <option key={s.uid} value={s.uid}>{s.name} ({s.role})</option>
                ))}
              </select>
            </div>

            <div className="task-modal__field">
              <label className="task-modal__label">Priority</label>
              <select
                className="task-modal__select"
                value={form.priority}
                onChange={e => onChange('priority', e.target.value)}
              >
                <option value="urgent">🔴 Urgent</option>
                <option value="high">🟠 High</option>
                <option value="medium">🟡 Medium</option>
                <option value="low">⚪ Low</option>
              </select>
            </div>
          </div>

          <div className="task-modal__row">
            <div className="task-modal__field">
              <label className="task-modal__label">Category</label>
              <select
                className="task-modal__select"
                value={form.category}
                onChange={e => onChange('category', e.target.value)}
              >
                {CATEGORIES.map(c => <option key={c} value={c}>{c}</option>)}
              </select>
            </div>

            <div className="task-modal__field">
              <label className="task-modal__label">Due Date / Time</label>
              <input
                className="task-modal__input"
                type="datetime-local"
                value={form.dueDate}
                onChange={e => onChange('dueDate', e.target.value)}
              />
            </div>
          </div>

          <div className="task-modal__field">
            <label className="task-modal__label">Internal Notes</label>
            <textarea
              className="task-modal__textarea"
              placeholder="Notes visible to assignee..."
              value={form.notes}
              onChange={e => onChange('notes', e.target.value)}
            />
          </div>

        </div>

        <div className="task-modal__footer">
          <button className="task-modal__cancel" onClick={onClose}>Cancel</button>
          <button
            className="task-modal__submit"
            onClick={onSave}
            disabled={saving || !canSubmit}
          >
            {saving ? 'Saving…' : editingTask ? 'Save Changes' : 'Assign Task'}
          </button>
        </div>

      </div>
    </div>
  );
}
